import UnauthorizedWithCode from 'govbr.frontend.policy/components/Errors/Unauthorized/Unauthorized';

UnauthorizedWithCode.displayName = 'unauthorized';
export default UnauthorizedWithCode;
